import { FaExpand, FaCompress } from 'react-icons/fa6';
import { twMerge } from 'tailwind-merge';

import { Button, ButtonProps } from '@/components/Button';

export type ExpandProps = ButtonProps & {
  isExpanded?: boolean;
};

export function Expand({ className, isExpanded, ...props }: ExpandProps) {
  const Icon = isExpanded ? FaCompress : FaExpand;

  return (
    <Button
      variant="outline"
      className={twMerge(
        'absolute top-32 right-3 flex flex-col gap-2 lg:right-20',
        'rounded-full bg-white',
        className,
      )}
      {...props}
    >
      <Icon className="size-5" />
    </Button>
  );
}
